export default "__VITE_ASSET__DMhM8_0C__"